import React from 'react';

import Button from '../../../common/ui/Button';
import Modal from '../../../common/ui/Modal';
import DisappointedSmileIcon from '../../../../assets/icons/common/DisappointedSmileIcon';
import SupportIcon from '../../../../assets/icons/common/SupportIcon';
import { openGladlyChat } from '../../../../utils/gladly';

import styles from './styles.module.scss';

const ErrorModal = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} className={styles.errorModal}>
      <div className={styles.content}>
        <DisappointedSmileIcon />
        <h3>Oops, something went wrong...</h3>
        <p>Please try again later or contact support</p>
      </div>
      <Button
        colorType={'white'}
        className={styles.button}
        onClick={openGladlyChat}
      >
        <SupportIcon /> Contact Support
      </Button>
    </Modal>
  );
};
export default ErrorModal;
